export const esContent = {
  introduction: {
    content: [
      "Desde su debut en 1996, la serie Pokémon ha cautivado corazones en todo el mundo, convirtiéndose en una de las marcas de entretenimiento más queridas globalmente. Nuestro Generador Aleatorio de Pokémon está diseñado para entrenadores de todas las edades que desean descubrir nuevos Pokémon, construir equipos equilibrados o simplemente disfrutar del elemento sorpresa en su viaje Pokémon.",
      "Ya seas un entrenador veterano buscando inspiración para tu próximo equipo de torneo o un fan casual que desea expandir su Pokédex, esta herramienta Randomizador de Pokémon ofrece una forma divertida e interactiva de explorar el vasto mundo Pokémon."
    ]
  },
  howToUse: {
    content: [
      "Usar nuestro Selector Aleatorio de Pokémon es simple e intuitivo. Sigue estos pasos para comenzar a generar tu equipo Pokémon perfecto:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Selecciona el número de Pokémon: Elige cuántos Pokémon deseas generar (1-8)." },
          { type: "text", content: "Elige un Tipo: Filtra por tipos específicos como Fuego, Agua, Eléctrico, o selecciona \"Cualquiera\" para incluir todos los tipos." },
          { type: "text", content: "Selecciona una Generación: Elige desde la Generación I hasta la VIII, o selecciona \"Cualquiera\" para incluir Pokémon de todas las generaciones." },
          { type: "text", content: "Establece preferencias de Rareza: Determina qué tan raros quieres que sean tus Pokémon generados." },
          { type: "text", content: "Haz clic en \"Generar\": Una vez que hayas establecido tus preferencias, haz clic en el botón para generar Pokémon que coincidan con tus criterios." },
          { type: "text", content: "Explora los Resultados: ¡Revisa la información detallada de cada Pokémon, incluyendo estadísticas, habilidades, tipos y más!" }
        ]
      },
      "Puedes repetir este proceso tantas veces como quieras, ajustando tus parámetros para descubrir diferentes combinaciones de Pokémon."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Completamente Gratis: Nuestro Generador Aleatorio de Pokémon es 100% gratuito, sin costos ocultos ni suscripciones." },
          { type: "text", content: "Experiencia Personalizable: Filtra por tipo, generación y rareza para adaptar tus selecciones aleatorias." },
          { type: "text", content: "Herramienta Educativa: Aprende sobre diferentes especies de Pokémon, sus estadísticas, habilidades y tipos." },
          { type: "text", content: "Construcción de Equipos: Genera rápidamente equipos equilibrados para juego casual o batallas competitivas." },
          { type: "text", content: "Creador de Desafíos: Crea desafíos únicos limitándote a Pokémon generados aleatoriamente." },
          { type: "text", content: "Sin Cuenta Requerida: Usa la herramienta instantáneamente sin registros ni información personal." }
        ]
      }
    ]
  },
  history: {
    content: [
      "La franquicia Pokémon comenzó en 1996 cuando Satoshi Tajiri creó los primeros juegos Pokémon para la Game Boy de Nintendo. Inspirado en su pasatiempo de la infancia de coleccionar insectos, el concepto se centró en capturar, entrenar y batallar con criaturas llamadas \"Pocket Monsters\" o Pokémon.",
      "Hitos clave en la historia de Pokémon:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Lanzamiento de Pokémon Rojo y Verde en Japón" },
          { type: "text", content: "1998: Lanzamiento internacional de Pokémon Rojo y Azul" },
          { type: "text", content: "1999: Lanzamiento mundial del Juego de Cartas Coleccionables Pokémon" },
          { type: "text", content: "2000: Introducción de Oro y Plata, añadiendo 100 nuevos Pokémon" },
          { type: "text", content: "2016: Lanzamiento de Pokémon GO, llevando la franquicia a plataformas móviles" },
          { type: "text", content: "2019: Debut de Pokémon Espada y Escudo en Nintendo Switch" }
        ]
      },
      "Hoy, con más de 900 especies diferentes de Pokémon a lo largo de ocho generaciones, la franquicia se ha expandido para incluir videojuegos, cartas coleccionables, series animadas, películas, mercancía y aplicaciones móviles, convirtiéndola en una de las franquicias de medios más rentables de todos los tiempos."
    ]
  },
  popularPokemon: {
    content: [
      "A lo largo de la historia de Pokémon, varias especies se han convertido en símbolos icónicos de la franquicia:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: La mascota de tipo Eléctrico de la franquicia, conocida por su cola en forma de rayo y mejillas rosadas." },
          { type: "text", content: "Charizard: Un favorito de los fans de tipo Fuego/Volador conocido por su apariencia similar a un dragón y poderosas habilidades." },
          { type: "text", content: "Mewtwo: Un legendario de tipo Psíquico creado mediante manipulación genética de Mew, conocido por su inmenso poder." },
          { type: "text", content: "Eevee: Amado por su única capacidad de evolucionar en diferentes tipos, incluyendo Vaporeon, Jolteon y Flareon." },
          { type: "text", content: "Gyarados: Un temible tipo Agua/Volador que evoluciona del humilde Magikarp." },
          { type: "text", content: "Lucario: Un tipo Lucha/Acero conocido por sus habilidades para detectar el aura y su popularidad en el juego competitivo." },
          { type: "text", content: "Greninja: Un Pokémon rana ninja de tipo Agua/Siniestro que ganó popularidad a través de la serie animada." }
        ]
      },
      "Nuestro Generador Aleatorio de Pokémon te da la oportunidad de descubrir estas criaturas icónicas y muchas otras especies menos conocidas pero igualmente fascinantes."
    ]
  },
  popularGames: {
    content: [
      "La serie de juegos Pokémon ha producido numerosos títulos queridos a través de múltiples plataformas:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Rojo, Azul y Amarillo: Los juegos originales que iniciaron el fenómeno en Game Boy." },
          { type: "text", content: "Pokémon Oro, Plata y Cristal: Introdujeron la región de Johto y ciclos de día/noche." },
          { type: "text", content: "Pokémon Rubí, Zafiro y Esmeralda: Expandieron el mundo con la región de Hoenn y batallas dobles." },
          { type: "text", content: "Pokémon Diamante, Perla y Platino: Llevaron la serie a Nintendo DS con funcionalidad en línea." },
          { type: "text", content: "Pokémon Negro y Blanco: Presentaron un conjunto completamente nuevo de Pokémon y un enfoque más orientado a la historia." },
          { type: "text", content: "Pokémon X e Y: Introdujeron modelos 3D y Megaevolución." },
          { type: "text", content: "Pokémon Sol y Luna: Reinventaron el sistema de gimnasios con las Pruebas de Isla." },
          { type: "text", content: "Pokémon GO: El juego de realidad aumentada móvil que se convirtió en un fenómeno global." },
          { type: "text", content: "Pokémon Espada y Escudo: Llevaron la serie a Nintendo Switch con el concepto del Área Silvestre." },
          { type: "text", content: "Leyendas Pokémon: Arceus: Un nuevo enfoque de mundo abierto para la serie." }
        ]
      },
      "Cada juego introduce nuevas mecánicas y Pokémon, expandiendo el universo que nuestro Generador Aleatorio de Pokémon te ayuda a explorar."
    ]
  },
  tradingContests: {
    content: [
      "El intercambio de Pokémon ha sido un aspecto fundamental de la franquicia desde su inicio. Los juegos originales fueron lanzados en pares específicamente para alentar a los jugadores a intercambiar con amigos para completar su Pokédex. Este elemento social ayudó a difundir la popularidad de Pokémon y sigue siendo importante hoy en día.",
      "Aspectos clave del intercambio:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon exclusivos de versión que solo pueden obtenerse mediante intercambio" },
          { type: "text", content: "Evoluciones por intercambio para ciertas especies como Machoke y Kadabra" },
          { type: "text", content: "Sistemas de Intercambio Global en juegos modernos que permiten intercambios mundiales" },
          { type: "text", content: "Intercambio de Pokémon raros o variocolor como símbolos de estatus" }
        ]
      },
      "Los Concursos Pokémon, introducidos en la Generación III, ofrecen una alternativa a las batallas donde los Pokémon compiten basándose en apariencia, rendimiento y atractivo en lugar de fuerza. Estos concursos incluyen:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Diferentes categorías de concurso (Carisma, Belleza, Dulzura, Ingenio, Dureza)" },
          { type: "text", content: "Movimientos especiales diseñados específicamente para concursos" },
          { type: "text", content: "Gestión de la condición del Pokémon a través de bayas y pokochos" },
          { type: "text", content: "Competiciones de múltiples etapas con juicios visuales preliminares y rondas de actuación" }
        ]
      },
      "Nuestro Generador Aleatorio de Pokémon puede ayudarte a descubrir Pokémon que podrían destacar en concursos o ser valiosos compañeros de intercambio, añadiendo otra dimensión a tu experiencia Pokémon."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "¿Este Generador Aleatorio de Pokémon es gratuito?",
            answer: "Sí, nuestra herramienta es completamente gratuita sin costos ocultos ni requisitos de suscripción."
          },
          {
            type: "faq",
            question: "¿Qué tan precisos son los datos de Pokémon?",
            answer: "Todos los datos provienen de la PokéAPI oficial, asegurando precisión e información actualizada."
          },
          {
            type: "faq",
            question: "¿Puedo generar Pokémon de una generación específica?",
            answer: "Sí, puedes filtrar por generación desde la I hasta la VIII, o elegir \"Cualquiera\" para incluir todas las generaciones."
          },
          {
            type: "faq",
            question: "¿Cómo funciona el filtro de rareza?",
            answer: "Nuestro algoritmo asigna valores de rareza basados en factores como el estado legendario/mítico, experiencia base y otros atributos para crear una escala de rareza del 1 al 10."
          },
          {
            type: "faq",
            question: "¿Puedo guardar o exportar los Pokémon generados?",
            answer: "Actualmente, puedes tomar capturas de pantalla de tus resultados. Estamos considerando añadir funcionalidad de guardar/exportar en futuras actualizaciones."
          },
          {
            type: "faq",
            question: "¿El Generador Aleatorio de Pokémon es compatible con dispositivos móviles?",
            answer: "Sí, nuestro generador es totalmente responsive y funciona en smartphones, tablets y computadoras de escritorio."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Nuestro Generador Aleatorio de Pokémon ofrece posibilidades infinitas tanto para fans casuales como para entrenadores dedicados. Ya sea que estés buscando descubrir nuevos favoritos, crear equipos temáticos o desafiarte a ti mismo con combinaciones inesperadas, nuestra herramienta proporciona una manera divertida y educativa de explorar el vasto mundo de Pokémon.",
      "Trabajamos constantemente para mejorar el generador con nuevas características y opciones. ¡Pruébalo hoy ajustando tus preferencias y haciendo clic en \"Generar\" para ver qué Pokémon te esperan!",
      "¡Comparte tus resultados con amigos y otros entrenadores, y cuéntanos cómo estás usando el Generador Aleatorio de Pokémon en tu viaje Pokémon. ¡Feliz cacería!"
    ]
  }
}; 